import { Tag } from "~/models/list";
import { BaseTag } from "./BaseTag";
import { formatSizeTag, formatSizeTagTooltip } from "~/utils/tags";
import Tooltip from "~/common/Tooltip";
import { InfoCircleFilled } from "~/common/icons/InfoCircleFilled";
import classNames from "classnames";

interface SizeTagProps {
  tag?: Tag;
  className?: string;
}

export function SizeTag(props: SizeTagProps) {
  const sizeTagName = formatSizeTag(props.tag?.name);
  const sizeTagTooltip = formatSizeTagTooltip(props.tag?.name);

  return (
    <BaseTag
      tag={{ name: sizeTagName, url: props.tag?.url }}
      className={props.className}
      trailingContent={
        sizeTagName && sizeTagTooltip ? (
          <div className="tw:inline-flex tw:flex-shrink-0 tw:justify-center">
            <Tooltip message={sizeTagTooltip}>
              <button
                className={classNames(
                  "tw:inline-flex tw:!p-0 tw:!bg-transparent tw:!border-0 tw:cursor-pointer tw:text-cn-dark-blue!",
                  "focus:tw:outline-none focus:tw:ring-2 focus:tw:ring-cn-dark-blue focus:tw:ring-offset-1",
                )}
                type="button"
                aria-label={`Show nonprofit size: ${sizeTagTooltip}`}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onTouchStart={(e) => {
                  e.stopPropagation();
                }}
              >
                <InfoCircleFilled className="tw:w-[18px] tw:h-[18px] tw:ml-3" />
              </button>
            </Tooltip>
          </div>
        ) : null
      }
    />
  );
}
